import api from './api';

export const assessmentService = {
  // Get all assessments
  getAssessments: async () => {
    const response = await api.get('/assessments');
    return response.data;
  },

  // Get specific assessment by slug
  getAssessment: async (slug) => {
    const response = await api.get(`/assessments/${slug}`);
    return response.data;
  },

  // Submit completion
  submitCompletion: async (completionData) => {
    const response = await api.post('/completions', completionData);
    return response.data;
  },

  // Check whether an email already has an account
  checkEmailExists: async (email) => {
    const response = await api.post('/auth/check-email', { email });
    return response.data;
  },

  // Link a guest completion to the logged-in account
  linkCompletionToAccount: async (completionId) => {
    const response = await api.post('/auth/link-completion-to-account', {
      completion_id: completionId
    });
    return response.data;
  },

  // Get user completions (requires auth)
  getUserCompletions: async () => {
    const response = await api.get('/dashboard/completions');
    return response.data;
  }
};

export const authService = {
  // Register new user
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Login
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },

  // Check if user is logged in
  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },

  // Get user from localStorage
  getUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }
};
